import {
  AppDetails,
  FirebaseConfig,
  PurchaseDetails,
  cloud_function_server_url,
  language,
  mainUrl
} from '../../config';
import {
  CHECK_SUCCESS,
  CLEAR_LOGIN_ERROR,
  FETCH_USER,
  FETCH_USER_FAILED,
  FETCH_USER_SUCCESS,
  REQUEST_OTP,
  REQUEST_OTP_FAILED,
  REQUEST_OTP_SUCCESS,
  SEND_RESET_EMAIL,
  SEND_RESET_EMAIL_FAILED,
  SEND_RESET_EMAIL_SUCCESS,
  UPDATE_USER_PROFILE,
  USER_DELETED,
  USER_SIGN_IN,
  USER_SIGN_IN_FAILED,
  USER_SIGN_OUT,
  USER_UPDATE_PASSWORD,
  USER_UPDATE_PASSWORD_FAILED,
  USER_UPDATE_PASSWORD_SUCCESS,
  UPDATE_DRIVERSTATUS_PROFILE
} from "../store/types";

const END_POINT = `${cloud_function_server_url}/auth`;
const USER_END_POINT = `${cloud_function_server_url}/user`;
const CAR_END_POINT = `${cloud_function_server_url}/cars`;

export const monitorProfileChanges = () => (dispatch) => (firebase) => {
  const {
    auth,
    singleUserRef,
  } = firebase;
  singleUserRef(auth.currentUser.uid).child('queue').on('value', res => {
    singleUserRef(auth.currentUser.uid).once('value', res => {
      dispatch({
        type: UPDATE_USER_PROFILE,
        payload: res.val()
      });
    });
  });
  singleUserRef(auth.currentUser.uid).child('walletHistory').on('value', res => {
    singleUserRef(auth.currentUser.uid).once('value', res => {
      dispatch({
        type: UPDATE_USER_PROFILE,
        payload: res.val()
      });
    });
  });
}

// export const fetchUser = () => (dispatch) => (firebase) => {
//   const {
//     auth,
//     singleUserRef,
//     settingsRef,
//   } = firebase;

//   dispatch({
//     type: FETCH_USER,
//     payload: null
//   });
//   auth.onAuthStateChanged(user => {
//     if (user) {
//       try {
//         fetch(`https://us-central1-seradd.${mainUrl}/baseset`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             license: PurchaseDetails.CodeCanyon_Purchase_Code ? PurchaseDetails.CodeCanyon_Purchase_Code : ' ',
//             contact_email: PurchaseDetails.Buyer_Email_Address ? PurchaseDetails.Buyer_Email_Address : ' ',
//             app_name: AppDetails.app_name,
//             app_identifier: AppDetails.app_identifier,
//             projectId: FirebaseConfig.projectId,
//             createTime: new Date().toISOString(),
//             reqType: 'auth'
//           })
//         })
//           .then(response => response.json())
//           .then((res) => {
//             if (res) {
//               settingsRef.once("value", settingdata => {
//                 let settings = settingdata.val();
//                 let password_provider_found = false;
//                 let waitTime = 0;
//                 for (let i = 0; i < user.providerData.length; i++) {
//                   if (user.providerData[i].providerId == 'password') {
//                     password_provider_found = true;
//                     break;
//                   }
//                   if (user.providerData[i].providerId == 'facebook.com' || user.providerData[i].providerId == 'apple.com') {
//                     waitTime = 2000;
//                     break;
//                   }
//                 }
//                 if ((password_provider_found && settings.email_verify && user.emailVerified) || !settings.email_verify || !password_provider_found) {
//                   setTimeout(() => {
//                     singleUserRef(user.uid).once("value", snapshot => {
//                       if (snapshot.val()) {
//                         user.profile = snapshot.val();
//                         if (user.profile.approved) {
//                           dispatch({
//                             type: FETCH_USER_SUCCESS,
//                             payload: user
//                           });
//                         } else {
//                           auth.signOut();
//                           dispatch({
//                             type: USER_SIGN_IN_FAILED,
//                             payload: { code: language.auth_error, message: language.require_approval }
//                           });
//                         }
//                       }
//                     });
//                   }, waitTime);
//                 }
//                 else {
//                   user.sendEmailVerification();
//                   auth.signOut();
//                   dispatch({
//                     type: USER_SIGN_IN_FAILED,
//                     payload: { code: language.auth_error, message: language.email_verify_message }
//                   });
//                 }
//               });
//             }
//             else {
//               auth.signOut();
//               dispatch({
//                 type: USER_SIGN_OUT,
//                 payload: null
//               });
//               alert('Base Settings Error 2 1');
//             }
//           }).catch(error => {
//             auth.signOut();
//             dispatch({
//               type: USER_SIGN_OUT,
//               payload: null
//             });
//             alert('Base Settings Error 2 2');
//           })
//       } catch (error) {
//         auth.signOut();
//         dispatch({
//           type: USER_SIGN_OUT,
//           payload: null
//         });
//         alert('Base Settings Error 1');
//       }
//     } else {
//       dispatch({
//         type: FETCH_USER_FAILED,
//         payload: { code: language.auth_error, message: language.not_logged_in }
//       });
//     }
//   });
// };

export const fetchUser = () => (dispatch) => async (firebase) => {

  dispatch({
    type: FETCH_USER,
    payload: null
  });

  const data = localStorage.getItem("user");
  if (data) {
    let parsedData = JSON.parse(data);
    fetch(`${END_POINT}/fetch-one-user/${parsedData.uid}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(async (res) => {
        const response = await res.json();
        const data = response.data
        if(data) {
        const user = {
          uid: data.uid,
          profile: data,
          phoneNumber: data.mobile
        }

        if (user.profile.approved) {
          dispatch({
            type: FETCH_USER_SUCCESS,
            payload: user
          });
        } else {
          signOut()(dispatch)(firebase)
          dispatch({
            type: USER_SIGN_IN_FAILED,
            payload: { code: language.auth_error, message: language.require_approval }
          });
        }
      } else {
        signOut()(dispatch)(firebase)
        dispatch({
          type: USER_SIGN_IN_FAILED,
          payload: { code: language.auth_error, message: language.require_approval }
        });
      }
      }).catch(error => {
        console.log("fetch user error", error)

      });
  } else {
    dispatch({
      type: FETCH_USER_FAILED,
      payload: { code: language.auth_error, message: language.not_logged_in }
    });
  }
};

export const validateReferer = async (referralId) => {
  const response = await fetch(`${END_POINT}/validate-referrer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      referralId: referralId
    })
  })
  const json = await response.json();
  return json;
};

export const checkUserExists = async (regData) => {
  const response = await fetch(`${END_POINT}/check-user-exists`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: regData.email,
      mobile: regData.mobile
    })
  })
  const json = await response.json();
  return json;
};

export const resetPassword = async (password, token) => {
  const response = await fetch(`${END_POINT}/reset-email-password/${token}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      password
    })
  })
  const json = await response.json();
  return json;
};

export const checkOperatorExists = async (regData) => {
  const response = await fetch(`${cloud_function_server_url}/check_operator_exists`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: regData.email,
      mobile: regData.mobile
    })
  })
  const json = await response.json();
  return json;
};

export const checkVehicleExists = async (regData) => {
  const response = await fetch(`${CAR_END_POINT}/check-vehicle-exists`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      vehicleNo: regData.vehicleNo,
      // vehicleChasisNo: regData.vehicleChasisNo
    })
  })
  const json = await response.json();
  return json;
};

export const emailSignUp = (regData) => async (firebase) => {
  let url = `${END_POINT}/user-signup`;
  // regData.createdAt = new Date().toISOString();
  const response = await fetch(url, {
    method: 'POST',
    // headers: {
    //   'Content-Type': 'application/json',
    // },
    body: regData
  })
  return await response.json();
};

export const mobileSignUp = (regData) => async (firebase) => {

  let url = `${cloud_function_server_url}/user_mobilesignup`;
  regData.createdAt = new Date().toISOString();
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ regData: regData })
  })
  return await response.json();
};

export const mobileUserCreate = (regData) => async (firebase) => {

  let url = `${cloud_function_server_url}/user_mobileusercreate`;
  regData.createdAt = new Date().toISOString();
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ regData: regData })
  })
  return await response.json();
};

// export const requestPhoneOtpDevice = (phoneNumber, appVerifier) => (dispatch) => async (firebase) => {
//   const {
//     phoneProvider
//   } = firebase;

//   dispatch({
//     type: REQUEST_OTP,
//     payload: null
//   });
//   try {
//     const verificationId = await phoneProvider.verifyPhoneNumber(
//       phoneNumber,
//       appVerifier
//     );
//     dispatch({
//       type: REQUEST_OTP_SUCCESS,
//       payload: verificationId
//     });
//   }
//   catch (error) {
//     dispatch({
//       type: REQUEST_OTP_FAILED,
//       payload: error
//     });
//   };
// }

export const requestPhoneOtpDevice = async(phoneNumber) => {
  const response = await fetch(`${END_POINT}/request-otp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      phone: phoneNumber
    })
  })
  const json = await response.json();
  return json;
}

export const checkOtp = (code, otp) => (dispatch) => async (firebase) => {
  const {
    auth,
    mobileAuthCredential,
  } = firebase;
  auth.signInWithCredential(mobileAuthCredential(code, otp))
    .then((user) => {
      dispatch({
        type: CHECK_SUCCESS,
        payload: user.user.uid
      });
    }).catch(error => {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
}

export const mobileCheckOtp = (regData) => async (firebase) => {

  let url = `${cloud_function_server_url}/user_mobilecheckotp`;
  regData.createdAt = new Date().toISOString();
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ regData: regData })
  })
  return await response.json();
};

// export const mobileSignIn = (verficationId, code) => (dispatch) => (firebase) => {
//   const {
//     auth,
//     mobileAuthCredential,
//   } = firebase;

//   dispatch({
//     type: USER_SIGN_IN,
//     payload: null
//   });
//   auth.signInWithCredential(mobileAuthCredential(verficationId, code))
//     .then((user) => {
//       //OnAuthStateChange takes care of Navigation
//     }).catch(error => {
//       dispatch({
//         type: USER_SIGN_IN_FAILED,
//         payload: error
//       });
//     });
// };

export const mobileSignIn = (mobile, code) => (dispatch) => (firebase) => {
  // const {
  //   mobileAuthCredential,
  // } = Firebases;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  // auth().signInWithCredential(mobileAuthCredential(verficationId, code))
  //   .then((user) => {
  //     //OnAuthStateChange takes care of Navigation

  //   }).catch(error => {
  //     dispatch({
  //       type: USER_SIGN_IN_FAILED,
  //       payload: error.message
  //     });
  //   });


  let url = `${END_POINT}/driver-login`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ mobile, otpCode: code })
  })
    .then(async (res) => {
      const response = await res.json();
      const responseData = response.data;
      if (response.success) {
        localStorage.setItem("user", JSON.stringify(responseData))
        if (responseData) {
          const user = {
            uid: responseData.uid,
            profile: responseData,
            phoneNumber: responseData.mobile
          }
          if (user.profile.approved) {
            dispatch({
              type: FETCH_USER_SUCCESS,
              payload: user
            });
          } else {
            dispatch({
              type: USER_SIGN_IN_FAILED,
              payload: { code: language.auth_error, message: language.require_approval }
            });
          }
        } else {
          dispatch({
            type: FETCH_USER_FAILED,
            payload: { code: language.auth_error, message: language.not_logged_in }
          });
        }
      } else {
        dispatch({
          type: USER_SIGN_IN_FAILED,
          payload: response.message
        });
      }
    }).catch(error => {
      console.log("driver login error", error)
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error.message
      });
      return error
    });

};

export const updatePassword = (newpassword) => (dispatch) => (firebase) => {

  const { auth } = firebase;

  var user = auth.currentUser;

  dispatch({
    type: USER_UPDATE_PASSWORD,
    payload: null
  });

  user.updatePassword(newpassword).then(res => {
    dispatch({
      type: USER_UPDATE_PASSWORD_SUCCESS,
      payload: true
    });
  }).catch((error) => {
    dispatch({
      type: USER_UPDATE_PASSWORD_FAILED,
      payload: false
    });
  });
};


export const signIn = (email, password) => (dispatch) => (firebase) => {
  // console.log("inside sign in")
  // const {
  //   auth
  // } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });

  // auth
  //   .signInWithEmailAndPassword(email, password)
  //   .then(res => {
  //     //OnAuthStateChange takes care of Navigation
  //   })
  //   .catch(error => {
  //     console.log("signIn error", error)
  //     dispatch({
  //       type: USER_SIGN_IN_FAILED,
  //       payload: error
  //     });
  //   });

  fetch(`${END_POINT}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email,
      password
    })
  })
    .then(async (res) => {
      const response = await res.json();
      if (response?.success) {
        const data = response.data;
        localStorage.setItem("user", JSON.stringify(data))
        const user = {
          uid: data.uid,
          profile: data,
          phoneNumber: data.mobile
        }
        dispatch({
          type: FETCH_USER_SUCCESS,
          payload: user
        });
      } else {
        dispatch({
          type: USER_SIGN_IN_FAILED,
          payload: { code: response.success, message: response.message }
        });
      }
    }).catch(error => {
      console.log("res check error", error)
      dispatch({
        type: FETCH_USER_FAILED,
        payload: { code: language.auth_error, message: language.not_logged_in }
      });
      return error
    });
};

export const facebookSignIn = (token) => (dispatch) => (firebase) => {

  const {
    auth,
    facebookProvider,
    facebookCredential,
    singleUserRef
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  if (token) {
    const credential = facebookCredential(token);
    auth.signInWithCredential(credential)
      .then((user) => {
        if (user.additionalUserInfo) {
          singleUserRef(user.user.uid).once('value', snapshot => {
            if (!snapshot.val()) {
              let userData = {
                createdAt: new Date().toISOString(),
                firstName: user.additionalUserInfo.profile.first_name ? user.additionalUserInfo.profile.first_name : user.additionalUserInfo.profile.name ? user.additionalUserInfo.profile.name : ' ',
                lastName: user.additionalUserInfo.profile.last_name ? user.additionalUserInfo.profile.last_name : ' ',
                mobile: user.additionalUserInfo.profile.phoneNumber ? user.additionalUserInfo.profile.phoneNumber : ' ',
                email: user.additionalUserInfo.profile.email ? user.additionalUserInfo.profile.email : ' ',
                usertype: 'rider',
                referralId: (user.additionalUserInfo.profile.first_name ? user.additionalUserInfo.profile.first_name.toLowerCase() : 'temp') + Math.floor(1000 + Math.random() * 9000).toString(),
                approved: true,
                walletBalance: 0,
                loginType: 'facebook'
              }
              singleUserRef(user.user.uid).set(userData);
              updateProfile({ ...user.user, profile: {} }, userData);
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: USER_SIGN_IN_FAILED,
          payload: error
        });
      }
      );
  } else {
    auth.signInWithPopup(facebookProvider).then(function (result) {
      var token = result.credential.accessToken;
      const credential = facebookCredential(token);
      auth.signInWithCredential(credential)
        .then((user) => {
          if (user.additionalUserInfo) {
            singleUserRef(user.user.uid).once('value', snapshot => {
              if (!snapshot.val()) {
                let userData = {
                  createdAt: new Date().toISOString(),
                  firstName: user.additionalUserInfo.profile.first_name ? user.additionalUserInfo.profile.first_name : user.additionalUserInfo.profile.name ? user.additionalUserInfo.profile.name : ' ',
                  lastName: user.additionalUserInfo.profile.last_name ? user.additionalUserInfo.profile.last_name : ' ',
                  mobile: user.additionalUserInfo.profile.phoneNumber ? user.additionalUserInfo.profile.phoneNumber : ' ',
                  email: user.additionalUserInfo.profile.email ? user.additionalUserInfo.profile.email : ' ',
                  usertype: 'rider',
                  referralId: (user.additionalUserInfo.profile.first_name ? user.additionalUserInfo.profile.first_name.toLowerCase() : 'temp') + Math.floor(1000 + Math.random() * 9000).toString(),
                  approved: true,
                  walletBalance: 0,
                  loginType: 'facebook'
                }
                singleUserRef(user.user.uid).set(userData);
                updateProfile({ ...user.user, profile: {} }, userData);
              }
            });
          }
        })
        .catch(error => {
          dispatch({
            type: USER_SIGN_IN_FAILED,
            payload: error
          });
        }
        );
    }).catch(function (error) {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
  }
};

export const appleSignIn = (credentialData) => (dispatch) => (firebase) => {

  const {
    auth,
    appleProvider,
    singleUserRef
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  if (credentialData) {
    const credential = appleProvider.credential(credentialData);
    auth.signInWithCredential(credential)
      .then((user) => {
        if (user.additionalUserInfo) {
          singleUserRef(user.user.uid).once('value', snapshot => {
            if (!snapshot.val()) {
              let userData = {
                createdAt: new Date().toISOString(),
                firstName: ' ',
                lastName: ' ',
                mobile: ' ',
                email: user.additionalUserInfo.profile.email ? user.additionalUserInfo.profile.email : ' ',
                usertype: 'rider',
                referralId: 'rider' + Math.floor(1000 + Math.random() * 9000).toString(),
                approved: true,
                walletBalance: 0,
                loginType: 'apple'
              }
              singleUserRef(user.user.uid).set(userData);
              updateProfile({ ...user.user, profile: {} }, userData);
            }
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: USER_SIGN_IN_FAILED,
          payload: error
        });
      });
  } else {
    auth.signInWithPopup(appleProvider).then(function (result) {
      auth.signInWithCredential(result.credential)
        .then((user) => {
          if (user.additionalUserInfo) {
            singleUserRef(user.user.uid).once('value', snapshot => {
              if (!snapshot.val()) {
                let userData = {
                  createdAt: new Date().toISOString(),
                  firstName: ' ',
                  lastName: ' ',
                  mobile: ' ',
                  email: user.additionalUserInfo.profile.email ? user.additionalUserInfo.profile.email : ' ',
                  usertype: 'rider',
                  referralId: 'rider' + Math.floor(1000 + Math.random() * 9000).toString(),
                  approved: true,
                  walletBalance: 0,
                  loginType: 'apple'
                }
                singleUserRef(user.user.uid).set(userData);
                updateProfile({ ...user.user, profile: {} }, userData);
              }
            });
          }
        })
        .catch(error => {
          dispatch({
            type: USER_SIGN_IN_FAILED,
            payload: error
          });
        }
        );
    }).catch(function (error) {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
  }
};

// export const signOut = () => (dispatch) => (firebase) => {

//   const {
//     auth,
//   } = firebase;

//   auth
//     .signOut()
//     .then(() => {
//       dispatch({
//         type: USER_SIGN_OUT,
//         payload: null
//       });
//     })
//     .catch(error => {

//     });
// };

export const signOut = () => (dispatch) => async (firebase) => {

  // auth()
  //   .signOut()
  //   .then(() => {
  //     dispatch({
  //       type: USER_SIGN_OUT,
  //       payload: null
  //     });
  //   })
  //   .catch(error => {

  //   });
  const removeItem = await localStorage.removeItem("user");
  dispatch({
    type: USER_SIGN_OUT,
    payload: null
  });
};

export const deleteUser = (uid) => (dispatch) => (firebase) => {
  // const {
  //   singleUserRef,
  //   vehiclesRef,
  //   singleVehicleRef,
  //   auth
  // } = firebase;


  fetch(`${USER_END_POINT}/delete-user/${uid}`, {
    method: 'DELETE',
    headers: {
        'Content-Type': 'application/json',
    },
})
    .then(async (res) => {
        const response = await res.json();
        console.log("response", response)
    }).catch(error => {
        console.log("res check error", error)
    });

  // singleUserRef(uid).remove().then(() => {
  //   vehiclesRef.on("value", snapshot => {
  //     if (snapshot.val()) {
  //       const data = snapshot.val();
  //       const arr = Object.keys(data)
  //         .map(i => {
  //           data[i].id = i;
  //           return data[i];
  //         });

  //       arr.map(item => {
  //         if (item.driver === uid) {
  //           let vehicleObject = {
  //             driver: ""
  //           }
  //           singleVehicleRef(item.id).update(vehicleObject);
  //         }
  //       });
  //     }
  //   });
  //   if (auth.currentUser.uid == uid) {
  //     auth.signOut();
  //     dispatch({
  //       type: USER_DELETED,
  //       payload: null
  //     });
  //   }
  // });
};

export const updateProfile = (userAuthData, updateData) => (dispatch) => (firebase) => {

  let profile = userAuthData.profile;
  profile = { ...profile, ...updateData }
  dispatch({
    type: UPDATE_USER_PROFILE,
    payload: profile
  });

  fetch(`${USER_END_POINT}/update-profile`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ data: updateData })
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("updateProfile res", response)
    }).catch(error => {
      console.log("res update error", error)
    });
};

export const updateDriverStatus = (driverStatusData, updateData) => (dispatch) => (firebase) => {

  const {
    singleDriverStatusRef,
  } = firebase;

  let data = driverStatusData;
  let status = { ...data, ...updateData }
  dispatch({
    type: UPDATE_DRIVERSTATUS_PROFILE,
    payload: status
  });
  singleDriverStatusRef(driverStatusData.uid).update(updateData);
};


export const updateProfileImage = (userAuthData, imageBlob) => (dispatch) => (firebase) => {

  const {
    singleUserRef,
    profileImageRef,
  } = firebase;

  profileImageRef(userAuthData.uid).put(imageBlob).then(() => {
    imageBlob.close()
    return profileImageRef(userAuthData.uid).getDownloadURL()
  }).then((url) => {
    let profile = userAuthData.profile;
    profile.profileImage = url;
    singleUserRef(userAuthData.uid).update({
      profileImage: url
    });
    dispatch({
      type: UPDATE_USER_PROFILE,
      payload: profile
    });
  })
};

export const updatePushToken = (userAuthData, token, platform) => (dispatch) => (firebase) => {

  const {
    singleUserRef,
  } = firebase;

  let profile = userAuthData.profile;
  profile.pushToken = token;
  profile.userPlatform = platform;
  dispatch({
    type: UPDATE_USER_PROFILE,
    payload: profile
  });
  singleUserRef(userAuthData.uid).update({
    pushToken: token,
    userPlatform: platform
  });
};

export const clearLoginError = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_LOGIN_ERROR,
    payload: null
  });
};

export const sendResetMail = (email) => (dispatch) => (firebase) => {
  dispatch({
    type: SEND_RESET_EMAIL,
    payload: email
  });

  fetch(`${END_POINT}/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({email})
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("forgot-password",response)
      dispatch({
        type: SEND_RESET_EMAIL_SUCCESS,
        payload: {
          code: language.success,
          message: response.message
        }
      });
    }).catch(error => {
      dispatch({
        type: SEND_RESET_EMAIL_FAILED,
        payload: error.message
      });
    });
};
